import { render, staticRenderFns } from "./Visit-Table.vue?vue&type=template&id=6527efa6"
import script from "./Visit-Table.vue?vue&type=script&lang=js"
export * from "./Visit-Table.vue?vue&type=script&lang=js"
import style0 from "./Visit-Table.vue?vue&type=style&index=0&id=6527efa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports